import { useEffect, useState } from "react";
import { useApolloClient } from "react-apollo";
import { toast } from "react-toastify";
import { ALL_ROUTES_QUERY } from "../graphql/Routes/Routes.graphql";

function useAllowCustomerNoChange(RecId) {
  const client = useApolloClient();
  const [allowEdit, setAllowEdit] = useState(false);

  useEffect(() => {
    const fetchRoutes = async () => {
      try {
        const { data: RoutesData } = await client.query({
          query: ALL_ROUTES_QUERY,
          variables: {
            first: 1,
            where: {
              OR: [
                {
                  CustomerRecIdRef: RecId
                },
                {
                  BillToRecIdRef: RecId
                }
              ]
            },
            orderByMulti: ["RouteId_ASC"]
          },
          fetchPolicy: "network-only"
        });
        const routes = RoutesData?.Routes;
        if (routes) {
          setAllowEdit(!routes.length);
        }
      } catch (err) {
        toast.error(`Whoops! We encountered an error. Please contact support.`);
        console.error(err);
      }
    };
    if (RecId) {
      fetchRoutes();
    }
  }, [RecId, client]);

  return allowEdit;
}

export default useAllowCustomerNoChange;
